import React from "react";
import Button from "../Inputs/Button";

const Contact = () => {
  return (
    <div className="h-[444px] bg-center bg-contain bg-[url('./Assets/pattern/pattern.png')] bg-[#FFF] flex flex-col justify-center items-center gap-4 sm:gap-7">
      <h3 className="text-[#000] sm:max-w-[531px] px-4 text-center font-[600] text-[20px] sm:text-[38px] leadind-[15.49px] sm:leading-[54px]">
        Click the button to <br /> get in touch with us today!
      </h3>
      <Button
        allClasses={
          "h-[40px] w-[116px] text-[14px] items-center justify-center sm:text-[17px] bg-[#0E8A28] sm:h-[55px] sm:w-[166px] text-[#FFF] font-[500] "
        }
        type={"link"}
        link={"mailto:info.greengatepharma@gmail.com"}
        title={"Contact us"}
      />
    </div>
  );
};

export default Contact;
